import { EmploymentIndustry } from "../../lead-api";

const tKey = "inputs.employment.industry.";

export const genericEmploymentIndustryMenuItems: {
  label: string;
  value: EmploymentIndustry;
}[] = [
  ...Object.values(EmploymentIndustry)
    .filter((it) => it !== EmploymentIndustry.Other)
    .map((it) => ({ label: tKey + it.toLowerCase(), value: it })),
  {
    label: tKey + EmploymentIndustry.Other.toLowerCase(),
    value: EmploymentIndustry.Other,
  },
];
